import RiFileListLine from '@ben/icons/file-list-line';
import RiRobot2Line from '@ben/icons/robot-2-line';
import RiServiceLine from '@ben/icons/service-line';
import { NavLinksList } from '@ben/orion/left-navigation/common/styles';
import Layout from '@ben/orion/left-navigation/layout';
import NavLink from '@ben/orion/left-navigation/nav-link';
import RIcon from '@ben/orion/remix-icon';
import EmployeeCard from '../employee-card';

const LeftNavigation = () => {
  return (
    <Layout employeeCard={<EmployeeCard />} showBenGlow>
      <NavLinksList>
        <NavLink
          to={{ pathname: '/benefits', search: undefined }}
          label="Benefits"
          leftSection={<RIcon icon={RiServiceLine} />}
        />
        <NavLink
          to={{ pathname: '/autoben', search: undefined }}
          label="AutoBen"
          leftSection={<RIcon icon={RiRobot2Line} />}
        />
        <NavLink
          to={{ pathname: '/requirements', search: undefined }}
          label="Requirements"
          leftSection={<RIcon icon={RiFileListLine} />}
        />
      </NavLinksList>
    </Layout>
  );
};

export default LeftNavigation;
